import React, { useState } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { makeStyles } from '@mui/styles';
import { Grid, Typography, Button, TextField, FormControl, InputLabel, Select, MenuItem, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { portalCfg } from '../../config';
import CustomDivider from '../../components/CustomDivider';
import CustomHeader from '../../components/CustomHeader';
import { getAppConfig, getLogo } from '../../utils/commons';
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil';
import { configuration } from '../../config/main.config';
import CustomAlert from '../../components/CustomAlert';
import TermConditionController from '../term-condition/TermConditionController';
import { sortByPrice } from '../../utils/util';
import { HashLink } from 'react-router-hash-link';
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { PlaceIcon } from '../../components/CustomIcons';

const useStyles = makeStyles((theme) => ({
    top: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    bottom: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    package:{
        cursor:'pointer',
        width:'90%',
        height:400,
        [theme.breakpoints.up('sm')]: {
            width:'80%',
            height:400,
        },
        [theme.breakpoints.up('md')]: {
            width:'80%',
        },
        [theme.breakpoints.up('lg')]: {
            width:'94%',
        },
        [theme.breakpoints.up('xl')]: {
            width:'90%',
        },
    },
    item_image: {
        display: 'block',
        margin: 'auto',
        width: '100%',
    },
    item_image_logo: {
        width: '100%',
        height: 300,
        objectFit: 'contain',
    },
    term_condition: {
        cursor: 'pointer'
    },
    address_item: {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderBottom: '1px solid ' + theme.palette.background.primary,
    },
    address_selected: {
        backgroundColor: theme.palette.background.primary,
    },
    canSelected: {
        cursor: 'pointer',
    },
    select_container: {
        marginTop: theme.spacing(0.4)
    },
    select_input: {
        padding: '10.5px 18.5px 10.5px 18.5px!important',
        backgroundColor: theme.palette.common.white,
    },
    input: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        // height: '42px',
        padding: theme.spacing(1) + ' 0',
        width: '100%',
    },
    input_container: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        // height: '42px',
        padding: theme.spacing(1) + ' 0',
        width: '100%',
    },
    inputContainerFocus: {
        border: 'none',
    },
    inputRoot: {
        //color: theme.palette.common.white + "!important",
        padding: '10.5px 18.5px 10.5px 18.5px!important',
        background: theme.palette.common.white
    },
    textArea: {
        // minHeight: theme.spacing(24),
        height: 'auto',
    },
    //add css underline, 
    underline: {
        "&&&:before": {
            borderBottom: "none"
        },
        "&&:after": {
            borderBottom: "none"
        }
    },
    search_by: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    item_address: {
        padding: theme.spacing(1, 2),
    },
    list_item: {
        position: "absolute",
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        background: theme.palette.common.white,
        width: '100%',
        zIndex: 10,
        maxHeight: 200,
        overflow: 'auto'
    }
}));

export default function PackageContactView(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const items = [
        portalCfg.publicPath + "/images/banner/header_one.jpg",
        portalCfg.publicPath + "/images/banner/header_two.jpg"
    ]
    const {showModal, setShowModal, setChoosePackage, showTerm, showListAddresses, setShowListAddresses} = props;

    const appConfig = getAppConfig();
    const content = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.content ? appConfig.about_details.terms_conditions.content : null;
    const urlTerm = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.url ? appConfig.about_details.terms_conditions.url : null;

    return (
        <Grid item xs={12}>
            {/* <Carousel autoPlay showThumbs={false} infiniteLoop={true} showStatus={false}>
                {items.map((item, index) => <div key={index}><img src={item} /></div>)}
            </Carousel> */}
            <CustomHeader nomargin={true} hideMenu={true}/>
            <div>
                <HashLink to="#check_coverage" id='tag-check-coverage' style={{ display: 'none' }}>Check Coverage</HashLink>
                <HashLink to="#packages" id='tag-packages' style={{ display: 'none' }}>Packages</HashLink>
            </div>
            <Grid item xs={12} marginTop={10} textAlign='center'>
                <Typography variant='h1' color='primary'>{t('reorder_desc')}</Typography>
            </Grid>
            <Grid xs={12} marginTop={5} item container justifyContent="center">
                <CheckCoverage t={t} classes={classes} address={props.address} setAddress={props.setAddress} onCheckCoverage={props.onCheckCoverage}
                    searchType={props.searchType}
                    ispLocation={props.ispLocation}
                    setISPLocation={props.setISPLocation}
                    setSearchType={props.setSearchType}
                />
            </Grid>
            <Grid xs={12} marginTop={5} item container justifyContent="center">
                <SelectPackages packages={props.packages} onClickItem={props.onSelectPackage} choosePackage={props.choosePackage}/>
            </Grid>
            
            {showModal && <CustomAlert
                open={showModal}
                title={t('has_coverage')}
                isConfirm={true}
                showButtonClose={true}
                customMessage={<ContentHasCoverage t={t} classes={classes} onShowTerm={props.onShowTerm} setShowModal={props.setShowModal} content={content} urlTerm={urlTerm}/>}
                onClose={() => setShowModal(false)}
                confirmAction={{
                    okAction: () => {
                        setChoosePackage(true); 
                        setShowModal(false);
                        console.log("document.getElementById('tag-packages')===", document.getElementById('tag-packages'));
                        document.getElementById('tag-packages').click();
                    },
                    okTitle: t('btn_agree'),
                }}
            />}
            {showTerm && <TermConditionController 
                open={showTerm}
                onClose={() => props.onShowTerm(false)}
            />}
            {showListAddresses && <CustomAlert
                open={showListAddresses}
                isConfirm={true}
                showButtonClose={true}
                title={t('please_select_address')}
                customMessage={<ListAddresses 
                    t={t} 
                    classes={classes} 
                    addresses={props.addresses}
                    addressSelected={props.addressSelected}
                    setAddressSelected={props.setAddressSelected}
                />}
                onClose={() => {
                    props.setAddressSelected(null);
                    setShowListAddresses(false)
                }}
                confirmAction={{
                    okAction: () => {
                        setChoosePackage(true); 
                        setShowListAddresses(false);
                    },
                    okTitle: t('btn_ok'),
                }}
            />}
        </Grid>
    )
}

function ContentHasCoverage(props){
    const {t, classes, content, urlTerm} = props;

    return (
        <Grid item xs={12}>
            <Typography variant="subtitle2">{t('can_select_package')}</Typography>
            <Typography variant="subtitle2">{t('agree_term')} 
            <strong><span className={classes.term_condition} 
                onClick={content ? () => {
                    props.onShowTerm(true); 
                    props.setShowModal(false)
                } : () => window.open(urlTerm)}>
                    {t('term_condition')}
                </span>
            </strong> {t('of_service')}</Typography>
        </Grid>
    );
}

function ListAddresses(props){
    const {t, classes, addresses, addressSelected, setAddressSelected} = props;
    
    return (
        <Grid item xs={12}>
            {addresses && addresses.length > 0  && addresses.map((item, index) => {
                return (
                    <Grid item xs={12} key={index} className={addressSelected && addressSelected.objectID === item.objectID ? classes.address_selected : null}>
                        <Typography variant="subtitle2" className={classes.address_item} onClick={() => setAddressSelected(item)}>{item.address}</Typography>
                    </Grid>
                );
            })}
        </Grid>
    );
}

function CheckCoverage(props) {
    const { address, classes, t, setSearchType, searchType, ispLocation, setISPLocation } = props;
    console.log("searchType===", searchType);
    const [hideListItem, setHideListItem] = useState(undefined);
    const [valueAddress, setValueAddress] = useState(null);

    const options = {
        fields: ["address_components", "geometry", "icon", "name"],
        strictBounds: false,
        componentRestrictions: { country: ['za'] },
    };

    const {
        placePredictions,
        getPlacePredictions,
        isPlacePredictionsLoading
    } = useGoogle({
        apiKey: document._portalConfig.apiKeyMap,
        options,
    });

    const onChangeInput = (value) => {
        if(!value.includes('#')){
            setHideListItem(false);
            getPlacePredictions({ input: value });
            setValueAddress(value);
        }else{
            setValueAddress(value);
            let strAddress = value.split('#');
            if(strAddress && strAddress[1]){
                setISPLocation(strAddress[1]);
            }
        }
    };

    const onCheckAddress = () => {
        if(valueAddress.includes('#')){
            props.onCheckCoverage(1);
        }else {
            props.onCheckCoverage(0);
        }
    }

    console.log("placePredictions===", placePredictions);
    // console.log("isPlacePredictionsLoading===", isPlacePredictionsLoading);
    return (
        <Grid xs={11} sm={11} md={11} lg={8} xl={6} item container justifyContent="center" id="check_coverage">
            <CustomDivider />
            <Grid xs={12} item marginTop={2} container justifyContent="center">
                <Typography variant='h1' color='primary'>{t('check_your_coverage')}</Typography>
            </Grid>
            <Grid xs={12} item marginTop={0.5} container justifyContent="center">
                <Typography variant='p' color='primary'>{t('Enter your address again')}</Typography>
            </Grid>
            {/* <Grid item xs={12} container marginTop={2} spacing={1} className={classes.search_by} >
                <Grid item xs={3}>
                    <Grid xs={12} sm={12} item className={classes.input}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="custom-select-label">{"Search by"}</InputLabel>
                            <Select
                                labelId="custom-select-label"
                                id="custom-select"
                                fullWidth
                                onChange={(e) => {
                                    console.log("onchange e===", e)
                                    setSearchType(e.target.value);
                                }}
                                value={searchType}
                                className={classes.select_container}
                                inputProps={{ className: classes.select_input }}
                                label={t('Search by')}
                            >
                                <MenuItem value={0}>{t('Address')}</MenuItem>
                                <MenuItem value={1}>{t('Location reference')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={7}>
                    {searchType === 0 ? <GooglePlacesAutocomplete
                        apiKey={document._portalConfig.apiKeyMap}
                        autocompletionRequest={{
                            componentRestrictions: {
                                country: ['za'],
                            }
                        }}
                        selectProps={{
                            address,
                            onChange: props.setAddress,
                        }}
                    /> :
                        <TextField
                            name="search_address"
                            id="search_address"
                            className={classes.input_container}
                            InputProps={{
                                classes: {
                                    root: classes.inputContainer,
                                    input: classes.inputRoot,
                                    focused: classes.inputContainerFocus,
                                    underline: classes.underline,
                                    multiline: classes.textArea,
                                },
                            }}
                            value={ispLocation}
                            onChange={(e) => setISPLocation(e.target.value)}
                        />
                    }
                </Grid>
                <Grid item xs={2}>
                    {searchType === 0 && <Button size="small" color='primary' variant='outlined' onClick={() => props.setAddress(null)}>
                        {t('Clear')}
                    </Button>}
                </Grid>
            </Grid> */}
            <Grid item xs={12} style={{ position: 'relative' }}>
                <Grid item xs={12}>
                    <TextField
                        name="new_search_address"
                        id="new_search_address"
                        className={classes.input_container}
                        InputProps={{
                            classes: {
                                root: classes.inputContainer,
                                input: classes.inputRoot,
                                focused: classes.inputContainerFocus,
                                underline: classes.underline,
                                multiline: classes.textArea,
                            },
                        }}
                        value={valueAddress}
                        onChange={(e) => onChangeInput(e.target.value)}
                    />
                </Grid>
                {placePredictions && hideListItem === false && <Grid item xs={12} className={classes.list_item}>
                    {placePredictions.length > 0 &&
                        placePredictions.map((item, index) => {
                            return (
                                <ListItem key={index} onClick={() => {
                                    props.setAddress(item);
                                    setValueAddress(item.description)
                                    setHideListItem(true);
                                }} className={classes.item_address} button>
                                    <ListItemIcon>
                                        <PlaceIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={item.description} />
                                </ListItem>
                            );
                        })}
                </Grid>}
            </Grid>
            <Grid xs={12} item marginTop={2} container justifyContent="center">
                <Button color='primary' variant='contained' onClick={() => onCheckAddress()}>
                    {t('btn_check_coverage')}
                </Button>
            </Grid>
        </Grid>
    )
}

function SelectPackages(props){
    const {packages, choosePackage} = props;
    const { t } = useTranslation();
    return (
        <Grid xs={11} sm={11} md={11} lg={8} xl={6} item container justifyContent="center" id="packages">
            <CustomDivider />
            <Grid xs={12} item marginTop={2} container justifyContent="center">
                <Typography variant='h1' color='primary'>{t('select_your_package')}</Typography>
            </Grid>
            <Grid xs={12} item marginTop={0.5} container justifyContent="center">
                <Typography variant='p' color='primary'>{t('select_your_package_desc')}</Typography>
            </Grid>
            {/* <Packages packages={packages.vumatel} onClickItem={props.onClickItem}/>
            <Packages packages={packages.lte} onClickItem={props.onClickItem}/> */}
            <Packages packages={packages} onClickItem={props.onClickItem} choosePackage={choosePackage}/>
        </Grid>
    )
}

function Packages(props){
    const {packages, choosePackage} = props;
    const classes = useStyles();
    console.log("packages===", packages);
    return(
        <Grid xs={12} item marginTop={3} container justifyContent={'center'} direction="row" spacing={2}>
            {packages.map((item,index) => {
                return (
                    <Grid key={index} xs={6} sm={6} md={6} lg={3} className={choosePackage ? classes.canSelected : null} item onClick={choosePackage ? () => props.onClickItem(item) : () => {}}>
                        {item.image_url ? <img className={classes.item_image} src={item.image_url}/> 
                        : <img className={classes.item_image_logo} src={getLogo()}/>}
                    </Grid>
                )
            })}
        </Grid>
    )
}

function ProductImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url}/>
    } return <img className={props.classes.item_image_logo} src={getLogo()}/>;
}
